"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKeyParamsForInvalidation = getKeyParamsForInvalidation;

/**
 * When invalidating the query cache, we only want to use the key params that are defined so we can use the
 * hierarchical structure of the cache to invalidate all children
 *
 * Example: Log Entry Cache (see useLogEntry)
 *   - single log entries are stored in the query cache at key: ['logEntry', <orgId>, <logId>, <projectId>, <logEntryId>]
 *   - to invalidate a single log entry, we use the whole key: ['logEntry', <orgId>, <logId>, <projectId>, <logEntryId>]
 *   - to invalidate all entries of a particular log ACROSS sites, we use ['logEntry', <orgId>, <logId>]
 *      - NOTE: we do NOT pass undefined for the last 2 elements
 *   - and so on
 * Invalidation can happen at multiple levels for a log entry - a single entry, every entry (across logs) on an org, and
 * everything in between. Consumers of invalidation functions pass the params they want to use for invalidation, and when
 * some can be undefined, those need to be removed from the key so cache invalidation happens further up the hierarchy.
 *
 * This function takes <optionalParams> and returns a slice from the beginning up to (but not including) the first
 * undefined element. See test file for examples.
 *
 * @param optionalParams List of query key params. These should be ordered by where they are in the key's heirarchy
 */
function getKeyParamsForInvalidation(optionalParams) {
  var firstUndefined = optionalParams.indexOf(undefined);
  return optionalParams.slice(0, firstUndefined === -1 ? undefined : firstUndefined); // the logic of this function guarantees returning an array with no undefineds but TS doesn't know that
}